/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Suggest_IntroInputs */

const en_us2_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotted a wrong or odd sentence in this language? Tell us where it appears and how it should read. The team reviews every suggestion.`)
};

const pt_br2_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viu uma frase errada ou estranha neste idioma? Conte onde ela aparece e como ficaria melhor. A equipe revisa cada sugestão.`)
};

const es_419_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Viste una frase incorrecta o rara en este idioma? Cuéntanos dónde aparece y cómo debería decir. El equipo revisa cada sugerencia.`)
};

const pt_pt2_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viste uma frase errada ou estranha neste idioma? Diz-nos onde aparece e como ficaria melhor. A equipa revê cada sugestão.`)
};

const fr_fr2_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as repéré une phrase fausse ou bizarre dans cette langue ? Dis-nous où elle apparaît et comment elle devrait se lire. L’équipe examine chaque suggestion.`)
};

const de_de2_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist dir ein falscher oder seltsamer Satz in dieser Sprache aufgefallen? Sag uns, wo er steht und wie er besser lauten sollte. Das Team prüft jeden Vorschlag.`)
};

const it_it2_translation_suggest_intro = /** @type {(inputs: Translation_Suggest_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai notato una frase sbagliata o strana in questa lingua? Dicci dove compare e come dovrebbe essere. Il team esamina ogni suggerimento.`)
};

/**
* | output |
* | --- |
* | "Spotted a wrong or odd sentence in this language? Tell us where it appears and how it should read. The team reviews every suggestion." |
*
* @param {Translation_Suggest_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const translation_suggest_intro = /** @type {((inputs?: Translation_Suggest_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Suggest_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_translation_suggest_intro(inputs)
	if (locale === "es-419") return es_419_translation_suggest_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_suggest_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_translation_suggest_intro(inputs)
	if (locale === "de-DE") return de_de2_translation_suggest_intro(inputs)
	if (locale === "it-IT") return it_it2_translation_suggest_intro(inputs)
	return en_us2_translation_suggest_intro(inputs)
});
export { translation_suggest_intro as "translation.suggest_intro" }